import {
  UNSUPPORTED_INSURANCE_PLAN_MODAL,
  UNSUPPORTED_STATE_MODAL,
} from './constants'

export const dialogMap = {
  [UNSUPPORTED_STATE_MODAL]: {
    title: 'We are working hard on the ability to ship to your state!',
    description:
      'Please reach out to your insurance company to discuss your available options.',
  },
  [UNSUPPORTED_INSURANCE_PLAN_MODAL]: {
    titleA: 'Please enter your Insurance Carrier',
    titleB:
      "We're working hard to support your insurance, but we're not quite there yet.",
    description:
      "It's likely your insurance covers breast pumps! Please contact them to discuss your options and let them know you would like to use Babylist Health.",
  },
}
